import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';

const postEasyShipRates = createAsyncThunk('easyShipShipment/postEasyShipRates',
  async (formData, { rejectWithValue }) => {
    try {
      const data = await authSet(METHOD_POST, '/shipping/easyship/rates', formData);
      return {
        rates: data?.rates,
        errors: data?.errors,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postEasyShipRates;
